import * as apiCalls from '../api/ApiCalls';
import * as errorActions from './Error';
import * as modalAction from './Modal';
import * as waybillDataTypes from '../types/WaybillData';
import * as notificationActions from './Notification';
import {EditComplaintPosition} from './ComplaintPositions';
import {getComplaintById} from './Complaint';

export function updateNewWaybillNumberValue(waybillNumber) {
    return{ 
        type: waybillDataTypes.WAYBILL_DATA_UPDATE_NUMBER_VALUE,
        waybillNumber: waybillNumber,
        canSave: (waybillNumber.length > 0)
    };
}

export function updateWaybillDataCourier(courier) {
    return{
        type: waybillDataTypes.WAYBILL_DATA_UPDATE_COURIER_VALUE,
        payload: courier
    };
}

export function openUpdateWaybillDataModal(complaintId, waybillNumber, waybillCourier) {
    return (dispatch) => {
        dispatch(modalAction.openUpdateWaybillDataModal(complaintId,waybillNumber, waybillCourier)); 
    };
}

export function closeUpdateWaybillDataModal() {
    return (dispatch) => {
        dispatch(modalAction.hideModal());
    };
}

export function updateComplaintWaybillData(complaintId,waybillNumber, waybillCourier) {
    return async (dispatch, getState) => {
        try {
            dispatch(updateComplaintWaybillDataRequest());
            let complaint = await dispatch(getComplaintById(complaintId));
            complaint.waybillNumber = waybillNumber;
            complaint.waybillCourier = waybillCourier.enumValue;
            const response = await apiCalls.UpdateComplaintWaybillNumber(complaint);
            const result = await response.json();
            if(response.status===200) {
                dispatch(updateComplaintWaybillDataSuccess(result));
                let complaintPosition = getState().complaintPositions.positions.find(x=> x.id===complaintId);
                complaintPosition.waybillNumber = waybillNumber;
                complaintPosition.waybillCourier = waybillCourier;
                dispatch(EditComplaintPosition(complaintPosition));
                dispatch(notificationActions.addSuccessNotification("Zapis danych", "Pomyślnie zaktualizowano dane dotyczące listu przewozowego"));
            }
            else {
                return dispatch(errorActions.throwNewError("Błąd pobierania danych", result.exceptionMessage));
            }
        } catch (error) {
            return dispatch(errorActions.throwNewError("Błąd krytyczny!", "Nie można pobrać danych. Skontaktuj się z administratorem aplikacji"));
        }
    };
}

export function updateComplaintWaybillDataRequest(){
    return{
        type: waybillDataTypes.WAYBILL_DATA_UPDATE_WAYBILL_NUMBER_REQUEST
        
    };
}

export function updateComplaintWaybillDataFalure(error){
    return{
        type: waybillDataTypes.WAYBILL_DATA_UPDATE_WAYBILL_NUMBER_FAILURE,
        payload:error
    };
}



export function updateComplaintWaybillDataSuccess(waybillNumber){
    return{
        type: waybillDataTypes.WAYBILL_DATA_UPDATE_WAYBILL_NUMBER_SUCCESS,
        payload: waybillNumber
    };
}


// WEBPACK FOOTER //
// ./src/actions/WaybillData.js